module.exports = __webpack_public_path__ + "static/media/we_come_in_peace.4511954f.png";